import React from 'react';

function GetInTouch() {
	return (
		<div className="GetInTouch" id="contact">
			<div className="inner-wrapper">
				<div>
					<h3 className="title-color">
						<span>04.</span> Say Hello
					</h3>

					<p>
						I am currently looking for a new role in the software development
						field. I am open to learning new skills to improve as a developer
					</p>
					<div className="email-me">
						<a
							className="email-link"
							href="mailto:mosaelitsoane@gmail.com"
							target="_blank"
							rel="noreferrer">
							<h2 className="title">Get In Touch</h2>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default GetInTouch;
